/** @internal */
export enum PromiseUsingState {
  NOT_USED,
  RESOLVED,
  REJECTED,
}

/** @internal */
export class PromiseCompletionSource<T = void> {
  private readonly _promise: Promise<T>;
  private _resolve: ((s: T) => void) | undefined;
  private _reject: ((e: string | undefined) => void) | undefined;
  private _usingState: PromiseUsingState = PromiseUsingState.NOT_USED;

  public get UsingState(): PromiseUsingState {
    return this._usingState;
  }

  constructor() {
    this._promise = new Promise<T>((res, rej) => {
      this._reject = rej;
      this._resolve = res;
    });
  }

  public get Promise(): Promise<T> {
    return this._promise;
  }

  public Resolve(v: T): void {
    this._usingState = PromiseUsingState.RESOLVED;
    if (this._resolve != undefined) this._resolve(v);
  }

  public Reject(error: string | undefined = undefined): void {
    this._usingState = PromiseUsingState.REJECTED;
    if (this._reject != undefined) this._reject(error);
  }
}
